import { Insurer, Selection } from 'BrokerTsLib/src/enums'
import * as yup from 'yup'
import { customNullable, isInsurerAvailable, isInsurersAvailable } from ".."

export const PropertyRealtyValidationRuleObject = (realtyTypeId: any, hasBasement: any, insurers: any) => {
    const isAppartement = realtyTypeId == Selection.Byt.toString() || realtyTypeId == Selection.NajemniByt.toString()

    return {
        owner: yup
            .string()
            .nullable()
            .when([], () => {
                return realtyTypeId == Selection.Byt.toString()
                    ? yup
                        .string()
                        .nullable()
                        .required("Zvolte vlastnictví nemovitosti")
                    : yup.string().notRequired()
            }),

        apparmentType: yup
            .string()
            .when([], () => {
                return isAppartement
                    ? yup
                        .string()
                        .nullable()
                        .required("Vyberte zdali je bytový dům typový")
                    : yup.string().notRequired()
            }),

        isApproved: yup
            .boolean()
            .required("Zvolte jestli je nemovitost zkolaudována"),

        approvedYear:
            customNullable(yup.number())
                .when(["isApproved"], ([isApproved]) => {
                    return isApproved
                        ? customNullable(yup.number()).required("Zadejte rok kolaudace")
                        : customNullable(yup.number()).notRequired()
                }),

        builtUpArea:
            customNullable(yup.number())
                .required("Vyplňte celkovou podlahovou plochu"),

        builtUpCadastralArea:
            customNullable(yup.number())
                .required("Vyplňte zastavěnou plochu"),

        usefulArea:
            customNullable(yup.number())
                .when([], () => {
                    return realtyTypeId == Selection.Byt.toString() && isInsurersAvailable(insurers, [Insurer.KB])
                        ? customNullable(yup.number())
                            .required("Vyplňte užitnou plochu")
                        : customNullable(yup.number()).notRequired()
                }),

        apartmentNumber: yup
            .string()
            .nullable()
            .when([], () => {
                return isAppartement
                    ? yup.string().nullable().required("Zadejte číslo bytu")
                    : yup.string().nullable().notRequired()
            }),

        floorsCount:
            customNullable(yup.number())
                .when([], () => {
                    return !isAppartement
                        ? customNullable(yup.number()).required("Zadejte počet nadzemních podlaží").moreThan(0, "Počet nadzemních podlaží musí být větší než 0")
                        : customNullable(yup.number()).notRequired()
                }),

        roofType:
            customNullable(yup.number())
                .when([], () => {
                    return !isAppartement
                        ? customNullable(yup.number()).required("Zadejte typ střechy")
                        : customNullable(yup.number()).notRequired()
                }),

        atticArea:
            customNullable(yup.number())
                .when(["roofType", "isRoofResidential"], ([roofType, isRoofResidential]) => {
                    return !isAppartement
                        && roofType == Selection.StrechaSedlova
                        && isRoofResidential == false
                        && isInsurerAvailable(insurers, Insurer.Kooperativa)
                        ? customNullable(yup.number()).required("Vyplňte plochu podkroví")
                        : customNullable(yup.number()).notRequired()
                }),

        goodState: yup
            .boolean()
            .nullable()
            .when([], () => {
                return isInsurersAvailable(insurers, [
                    Insurer.Axa,
                    Insurer.Csob,
                    Insurer.Slavia,
                    Insurer.Kooperativa,
                    Insurer.GeneraliCeskaPojistovna,
                    Insurer.Allianz,
                    Insurer.Direct,
                    Insurer.Pillow,
                    Insurer.KB])
                    ? yup.boolean().nullable().required("Vyberte, zda budova je v dobrém technickém stavu")
                    : yup.boolean().nullable().notRequired()
            }),

        realtyAmount:
            customNullable(yup.number())
                .required("Zadejte hodnotu nemovitosti")
                .min(10000, "Minimální hodnota nemovitosti je 10 000 Kč"),

        basementArea: yup
            .string()
            .nullable()
            .when([], () => {
                return hasBasement == true && !isAppartement
                    ? yup.string().nullable().required("Vyberte plochu podsklepení")
                    : yup.string().nullable().notRequired()
            }),

        isRoofResidential: yup
            .boolean()
            .nullable()
            .when(["roofType"], ([roofType]) => {
                return !isAppartement && roofType == Selection.StrechaSedlova
                    ? yup.boolean().nullable().required("Zvolte jestli je střecha obytná")
                    : yup.boolean().nullable().notRequired()
            }),

        finishState:
            customNullable(yup.number())
                .when([], () => {
                    return !isAppartement
                        ? customNullable(yup.number()).required("Vyberte provedení budovy")
                        : customNullable(yup.number()).notRequired()
                }),

        structuralType:
            customNullable(yup.number())
                .when([], () => {
                    return !isAppartement
                        ? customNullable(yup.number()).required("Vyberte typ konstrukce")
                        : customNullable(yup.number()).notRequired()
                }),

        state:
            customNullable(yup.number())
                .when([], () => {
                    return !isAppartement
                        ? customNullable(yup.number()).required("Vyberte stav nemovitosti")
                        : customNullable(yup.number()).notRequired()
                }),


        secondaryRealty: yup
            .boolean()
            .nullable()
            .when([], () => {
                return !isAppartement
                    ? yup.boolean().nullable().required("Zvolte jestli existují vedlejší budovy")
                    : yup.boolean().nullable().notRequired()
            }),
    }
}

export const PropertyRealtyValidationSchema = (realtyTypeId: any, hasBasement: any, insurers: any) => yup.object().shape(PropertyRealtyValidationRuleObject(realtyTypeId, hasBasement, insurers))